import { deserialize, deserializeAs } from 'cerialize';

export class RAuditInfo {
    @deserialize
    public serialNumber: string;
    @deserialize
    public when: string;
    @deserialize
    public eventName: string;
    @deserialize
    public newValue: string;
    @deserialize
    public oldValue: string;
    @deserialize
    public message: string;
}

export class RAuditQueryResponse {
    @deserialize
    public lastKey: string;
    @deserializeAs(RAuditInfo)
    public items: Array<RAuditInfo> = [];
}

